var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tooltip",
    _vm._b(
      {
        attrs: {
          placement: _vm.placement,
          "popper-class": `custom_popper_class ${
            _vm.$attrs.popperClass !== undefined ? _vm.$attrs.popperClass : ""
          }`,
          disabled: _vm.isShowTooltip,
        },
      },
      "el-tooltip",
      _vm.$attrs,
      false
    ),
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c("span", {
          domProps: {
            innerHTML: _vm._s(_vm.data[_vm.keyName] || _vm.customStr),
          },
        }),
      ]),
      _c(
        "div",
        {
          staticClass: "overflow",
          on: {
            mouseover: function ($event) {
              return _vm.onIsShowTooltipByMouseOver(
                `${_vm.classStr}_${_vm.data.id || _vm.customId}`
              )
            },
          },
        },
        [
          _c("span", {
            attrs: { id: `${_vm.classStr}_${_vm.data.id || _vm.customId}` },
            domProps: {
              innerHTML: _vm._s(_vm.data[_vm.keyName] || _vm.customStr),
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }